import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { saveCreditsFormDataAC } from '../../store/actions/builderActions'
import { AppButton } from '../common/button/AppButton'
import { Centered } from '../common/centered/Centered'
import { CustomH2 } from '../common/customH2/CustomH2'
import { AppFileInput } from '../common/input/AppFileInput'
import { AppInput } from '../common/input/AppInput'
import styles from './Credits.module.css'

export const Credits = () => {
    const { artist, title } = useSelector(state => state.builder)
    const { register, watch, handleSubmit } = useForm()
    const [isDisabled, setIsdisabled] = useState(!artist && !title)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        const subscription = watch(value => setIsdisabled(Object.values(value).some(field => field === '')))
        return () => subscription.unsubscribe()
    }, [watch])

    const onSubmit = async (formData) => {
        await dispatch(saveCreditsFormDataAC(formData))
        navigate('/builder/art')
    }

    return <Centered>
        <form
            className={styles.credits}
            onSubmit={handleSubmit(onSubmit)}>
            {/* <div className={styles.header} > */}
                <CustomH2 >Tell us your artist's name and song title</CustomH2>
            {/* </div> */}
            <AppInput
                register={register}
                type='text'
                field='artist'
                placeholder={`artist's name`}
                value={artist}
            />
            <AppInput
                register={register}
                type='text'
                placeholder='song title'
                field='title'
                value={title}
            />
            <div className={styles.sendButtonContainer}>
                <AppButton
                    disabled={isDisabled}
                    type='submit'
                    value='next'
                />
            </div>
        </form>
    </Centered>
}